import {
  ALL_DOSSIER_REQUEST,
  ALL_DOSSIER_SUCCESS,
  ALL_DOSSIER_FAIL,
  ALL_DOSSIER_RESET,
} from "../../constants/medecinPS_constant";

import {
  PDF_REQUEST,
  PDF_SUCCESS,
  PDF_FAIL,
} from "../../constants/depot_constant";

import axios from "axios";
import { BASE_URL } from "../../axios/serverURL";
export const listDossiers = (id_medecin_PS) => async (dispatch) => {
  try {
    dispatch({ type: ALL_DOSSIER_REQUEST });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "reactMedecinPS",
      action: "get_total_dossier",
      id_medecin_PS: id_medecin_PS,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    console.log(data);
    dispatch({
      type: ALL_DOSSIER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ALL_DOSSIER_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

// get pdf to react page
export const getpdf = (id_depot) => async (dispatch, getState) => {
  try {
    dispatch({ type: PDF_REQUEST });
    const inputs = {
      headers: {
        "Content-type": "application/json",
      },
      object: "reactPatient",
      action: "reactPdf",
      id_depot: id_depot,
    };
    const { data } = await axios.post(BASE_URL, inputs);
    // console.log("action pdf");
    dispatch({
      type: PDF_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PDF_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
